import { render } from "./AdvancedMenu.vue?vue&type=template&id=30dcbb22&scoped=true"
import script from "./AdvancedMenu.vue?vue&type=script&lang=js"
export * from "./AdvancedMenu.vue?vue&type=script&lang=js"

import "./AdvancedMenu.vue?vue&type=style&index=0&id=30dcbb22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30dcbb22"]])

export default __exports__